import {
  ANY_AUTO_BRAND_DICTIONARY_SELECT_OPTION,
  ANY_AUTO_MODEL_DICTIONARY_SELECT_OPTION,
} from 'constants/dictionaries';

import { isSatisfyOption } from 'shared/lib';

import type { TCreditFormCommonFields } from 'entities/creditForm';
import { Numeric } from 'entities/creditForm/lib/formatters/base';

export class Auto {
  constructor(
    private readonly auto: Pick<
      TCreditFormCommonFields,
      'purpose' | 'autoModel' | 'autoBrand' | 'autoYear' | 'initialFee'
    >,
    // eslint-disable-next-line no-empty-function
  ) {}

  private toString(value: string | undefined | null | number) {
    if (!value) {
      return '';
    }

    return value.toString();
  }

  profile() {
    return {
      autoBrand: this.auto.autoBrand?.label || null,
      autoModel: this.auto.autoModel?.label || null,
      autoYear: parseInt(this.toString(this.auto.autoYear?.value), 10) || null,
      initialFee: new Numeric(this.auto.initialFee).format() || null,
    };
  }

  loans() {
    const isAutoPurpose = isSatisfyOption(['NewCar', 'UsedCar'], this.auto.purpose?.value);

    if (!isAutoPurpose) {
      return {
        initialFee: null,
        autoBrand: undefined,
        autoModel: undefined,
        autoYear: undefined,
      };
    }

    if (this.auto.autoBrand === null) {
      return {
        initialFee: new Numeric(this.auto.initialFee).format() ?? 0,
        autoModel: ANY_AUTO_BRAND_DICTIONARY_SELECT_OPTION.label,
        autoBrand: ANY_AUTO_MODEL_DICTIONARY_SELECT_OPTION.label,
        autoYear: undefined,
      };
    }

    const isAnyAutoModel = this.auto.autoModel?.value === ANY_AUTO_MODEL_DICTIONARY_SELECT_OPTION.value;
    if (isAnyAutoModel) {
      return {
        initialFee: new Numeric(this.auto.initialFee).format() ?? 0,
        autoBrand: this.auto.autoBrand?.label || null,
        autoModel: this.auto.autoModel?.label || null,
        autoYear: undefined,
      };
    }

    return {
      autoBrand: this.auto.autoBrand?.label || null,
      autoModel: this.auto.autoModel?.label || null,
      autoYear: parseInt(this.toString(this.auto.autoYear?.value), 10) || undefined,
      initialFee: new Numeric(this.auto.initialFee).format() ?? 0,
    };
  }
}
